import React, {Component} from 'react'
import moment from 'moment'
import { Tooltip } from 'reactstrap'

class DateCaso extends Component{
    constructor(props) {
        super(props);
        this.state = {
            tooltipInfo: false
        };
    }
    toggleTooltipInfo() {
        this.setState({
            tooltipInfo: !this.state.tooltipInfo
        });
    }
    isBefore(){
        return moment(moment(this.props.caso.created_at).add(7, 'days')).isAfter(this.props.caso.entrega)
    }
    render(){
        if(this.isBefore(this.props.caso)){
            return(
                <span className="text-danger" id={"tooltipInfo" + this.props.caso.id}>
                    <i className="fa fa-warning"></i> {moment(this.props.caso.entrega).format('DD-MM-YYYY')}
                    <Tooltip
                        placement="top"
                        isOpen={this.state.tooltipInfo}
                        target={"tooltipInfo" + this.props.caso.id}
                        toggle={this.toggleTooltipInfo.bind(this)}
                    >
                        Tiempo mínimo de entrega 7 días laborables
                    </Tooltip>
                </span>
            )
        }else{
            return(
                <span>{moment(this.props.caso.entrega).format('DD-MM-YYYY')}</span>
            )
        }
    }
}
export default DateCaso


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/DateCaso.jsx